import type { ComponentType } from 'react';
import {
  LazyBillingBusiness,
  LazyBillingIndividual,
  LazyBusinessOnboarding,
  LazyIndividualOnboarding,
  LazyIndividualProviderVerification,
  LazyServiceArea,
  LazyChooseAccountType,
  LandingPage,
  LazyProviderTeam,
  LazyMenuBuilder,
  LazyStripeFlow,
  LazySelectTreatmentLine,
  LazyBillingConfirm,
  LazyBillingSuccess,
  LazySubscriptionPage,
  LazySetupProfileStatus,
  LazyDashboard,
  LazyDashboardBookings,
  LazyDashboardProviders,
  LazyDashboardEarnings,
  LazyDashboardSettingsBusinessProfile,
  LazyDashboardSettingsBusinessProfileEdit,
  LazyDashboardSettingsNotifications,
  LazyDashboardSettingsSupport,
  LazyDashboardSettingsProviders,
  LazyDashboardSettingsManageBookings,
  LazyClinicalLiveBookings,
  LazyNonClinicalLiveBookings,
  LazyClinicalChecklist,
  LazyProviderReview,
  LazyVitalsRecorded,
  LazyIVMaterialsLogged,
  LazyDashboardSettingsSubscriptions,
  LazyDashboardSettingsCalendar,
  LazyDashboardSettingsLocation,
} from './lazyPages';

export type ProtectedRouteDef = {
  path: string;
  Page: ComponentType;
};

/** Authenticated onboarding / app flows — order is documentation only; routing is path-based. */
export const protectedRoutes: ProtectedRouteDef[] = [
  { path: '/choose-account', Page: LazyChooseAccountType },
  { path: '/select-treatment', Page: LazySelectTreatmentLine },
  { path: '/business-information', Page: LazyBusinessOnboarding },
  { path: '/individual-information', Page: LazyIndividualOnboarding },
  { path: '/individual-provider-verification', Page: LazyIndividualProviderVerification },
  { path: '/service-area', Page: LazyServiceArea },
  { path: '/billing/individual', Page: LazyBillingIndividual },
  { path: '/billing/business', Page: LazyBillingBusiness },
  // 🔥 NEW (VERY IMPORTANT)
  { path: '/billing/confirm', Page: LazyBillingConfirm },
  { path: '/billing/success', Page: LazyBillingSuccess },
  { path: '/billing/subscription', Page: LazySubscriptionPage },
  { path: '/provider-team', Page: LazyProviderTeam },
  { path: '/menu-builder', Page: LazyMenuBuilder },
  { path: '/stripe-flow', Page: LazyStripeFlow },
  { path: '/profileStatus', Page: LazySetupProfileStatus },
  { path: '/Dashboard', Page: LazyDashboard },
  { path: '/Dashboard/Bookings', Page: LazyDashboardBookings },
  { path: '/clinical-live-bookings', Page: LazyClinicalLiveBookings },
  { path: '/non-clinical-bookings', Page: LazyNonClinicalLiveBookings },
  { path: '/clinical-checklist', Page: LazyClinicalChecklist },
  { path: '/provider-review', Page: LazyProviderReview },
  { path: '/vitals-recorded', Page: LazyVitalsRecorded },
  { path: '/iv-materials-logged', Page: LazyIVMaterialsLogged },
  { path: '/Dashboard/Providers', Page: LazyDashboardProviders },
  { path: '/Dashboard/Earnings', Page: LazyDashboardEarnings },

  // Dashboard Settings (submenu + pages)
  { path: '/Dashboard/Settings/business-profile', Page: LazyDashboardSettingsBusinessProfile },
  { path: '/Dashboard/Settings/business-profile/edit', Page: LazyDashboardSettingsBusinessProfileEdit },
  { path: '/Dashboard/Settings/providers', Page: LazyDashboardSettingsProviders },
  { path: '/Dashboard/Settings/manage-bookings', Page: LazyDashboardSettingsManageBookings },
  { path: '/Dashboard/Settings/subscriptions', Page: LazyDashboardSettingsSubscriptions },
  { path: '/Dashboard/Settings/location', Page: LazyDashboardSettingsLocation },
  { path: '/Dashboard/Settings/calendar', Page: LazyDashboardSettingsCalendar },
  { path: '/Dashboard/Settings/notifications', Page: LazyDashboardSettingsNotifications },
  { path: '/Dashboard/Settings/support', Page: LazyDashboardSettingsSupport },
];

export const publicHomePage = LandingPage;
